import { chain } from 'lodash';
import React, { memo } from 'react';
import { ProjectKeywordGq } from '../../../../../../graphql/projects/models/ProjectKeywordGq';
import moment from 'moment';

export interface VolumeSmallSvgProps {
  keyword: ProjectKeywordGq;
  endMonth?: string;
}

const VolumeSmallSvg: React.FC<VolumeSmallSvgProps> = memo(({ keyword, endMonth }) => {
  const parsedEndMonth = moment.utc(endMonth).month();
  const endMonthIndex = 12 - parsedEndMonth - 1;
  let monthValues12 = chain(keyword.months2)
    .slice(36 - 12)
    .value();
  // monthValues12 = [...monthValues12.slice(endMonthIndex), ...monthValues12.slice(0, endMonthIndex)];

  const maxValue12 = Math.max(chain(monthValues12).max().value() ?? 1, 1);
  const baseHeight = 16;
  return (
    <svg width={30} height={baseHeight}>
      {monthValues12?.map((month, index) => (
        <rect
          key={index}
          height={baseHeight * ((month ?? 0) / maxValue12)}
          width={1.4}
          x={index * 2.6}
          y={baseHeight - baseHeight * ((month ?? 0) / maxValue12)}
          className={'fill-primary-700'}
        />
      ))}
    </svg>
  );
});

export default VolumeSmallSvg;
